export class RoleFilters
{
  id: number;
  filter: Array<any>;
  filterExpression: Array<any>;
}
